module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "poem1",
    attrs: {
      "id": "dedication"
    }
  }, [_vm._v("for two who")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("slipped away")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("almost")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("entirely:")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("my “part” Cherokee")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("great-grandmother")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Tallulah")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("(Grandmama Lula)")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("on my mother’s side")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("about whom")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("only one")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("agreed-upon")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("thing")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("is known:")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("her hair was so long")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("she could sit on it;")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("and my white (Anglo-Irish?)")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("great-great-grandfather")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("on my father’s side;")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("nameless")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("(Walker, perhaps?),")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("whose only remembered act")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("is that he raped")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("a child:")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("my great-great-grandmother,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("who bore his son,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("my great-grandfather,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("when she was eleven.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Rest in peace.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("The meaning of your lives")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("is still")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("unfolding.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Rest in peace.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("In me")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("the meaning of your lives")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("is still")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("unfolding.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Rest in peace, in me.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("The meaning of your lives")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("is still")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("unfolding.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Rest. In me")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("the meaning of your lives")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("is still")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("unfolding.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Rest. In peace")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("in me")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("the meaning")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("of our lives")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("is still")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("unfolding.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Rest.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bff2867","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3-dedication.vue
// module id = 66
// module chunks = 0